import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { AffiliateSchema, AffiliateReadSchema, AddressSchema, BankingInfoSchema, SocialMediaSchema, PerformanceSchema } from "model/_base/affiliates";

// Yup Schemas
export const DataSchema = AffiliateReadSchema.clone()
  .transform(transformSnakeToCamel)
  .concat(Yup.object().transform(transformSnakeToCamel))
  .shape({
    address: AddressSchema.default(undefined),
    bankingInfo: BankingInfoSchema.default(undefined),
    socialMedia: Yup.array().of(SocialMediaSchema).default(undefined),
    performance: PerformanceSchema.default(undefined),
    active: Yup.object().shape({
      at: Yup.date().nullable(),
      reason: Yup.string().nullable(),
    }),
  });

export const ApprovedPartnersSchema = Yup.object().shape({
  data: Yup.array().of(DataSchema),
  pagination: PaginationSchema,
});

export default class ApprovedPartnersModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = ApprovedPartnersSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      console.log(model);
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed json
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
